import React from 'react';
import Field from '../Field';

export default props => <Field alignContent {...props} />;
